import {SingleScoDataMap} from "scorm/common/SingleScoDataMap";
import {StatusCalculator} from "scorm/scorm_1_2/ScormCourseStatusCalculator";

export function SingleScoData() {

    const lmsRelevant = [
        "cmi.core.lesson_location",
        "cmi.core.lesson_status",
        "cmi.core.exit",
        "cmi.core.score.raw"
    ];

    // lms values
    let scoData = new SingleScoDataMap([
        ["cmi.student_data.mastery_score", "80"],

        ["cmi.core._children", "student_id,student_name,lesson_location,lesson_status,lesson_mode,entry,score"],
        ["cmi.core.credit", "credit"],
        ["cmi.core.lesson_location", "index"],
        ["cmi.core.lesson_status", ""],
        ["cmi.core.exit", ""],
        ["cmi.core.score.raw", ""],
        ["cmi.core.session_time", "00:00:00"],
        ["cmi.suspend_data", ""],

        ["cmi.core.score._children", "raw"],
        ["cmi.student_data._children", "mastery_score"],
        ["cmi.student_data.max_time_allowed", ""],
        ["cmi.student_data.time_limit_action", ""],
        ["cmi.core.student_name", ""],
        ["cmi.core.lesson_mode", "normal"],

        // AICC stores this data
        ["cmi.core.student_id", ""],
        ["cmi.core.student_name", ""],
        ["cmi.core.entry", "c"]
    ]);

    function isNotAttempted(){
        return scoData.get("cmi.core.lesson_status") === "not attempted";
    }

    function getMasteryScore() {
        return parseFloat( scoData.get("cmi.student_data.mastery_score") );
    }

    return {
        set: scoData.set,
        get: scoData.get,
        isValid: scoData.isValid,
        isForCredit: () => {
            return scoData.get("cmi.core.credit") === "credit";
        },
        isNotAttempted: isNotAttempted,
        isCourseManagedValue: (dataModelId) => {
            return dataModelId === "cmi.student_data.mastery_score"
                || dataModelId ==="cmi.core.credit";
        },
        checkSuspendDataSize: () => {

            if( typeof window.COURSE_DATA_API !== "undefined" ){
                return true;
            }

            const suspendData = scoData.get("cmi.suspend_data");
            return suspendData.length < 4096;
        },

        forEachLmsRelevantValue: function( callback ){
            lmsRelevant.forEach( ( dataModelId ) => {

                const value = scoData.get( dataModelId );
                if( !value ) {
                    return;
                }

                if ((dataModelId === "cmi.core.lesson_status") && isNotAttempted() ) {
                    return;
                }

                callback( value, dataModelId );
            });
        },

        refreshStatus: ( courseStatus, suspendData, lapsedTime ) => {

            const forCredit = scoData.get("cmi.core.credit") === "credit",
                  status = StatusCalculator.calculateStatus( courseStatus, getMasteryScore(), forCredit );

            scoData.set("cmi.core.score.raw", status.score.toString() );
            scoData.set("cmi.core.lesson_status", status.lessonStatus);
            scoData.set("cmi.core.exit", status.exitStatus);
            scoData.set("cmi.suspend_data", suspendData );
            scoData.set("cmi.core.session_time", lapsedTime );
        }
    };
}
